import { find, propEq, applySpec, prop } from 'ramda';
import { isNotNilOrEmpty } from '@@serverHelpers/index.mjs';

export const formatCcnValues = ({ noCCN, validatedCcn, validatedCcnRef, ccnRef, ccns, otherCcns }) => {
  if (noCCN) return { ccnId: '9999', ccnName: null, ccnRef: null };
  if (isNotNilOrEmpty(validatedCcn) && isNotNilOrEmpty(validatedCcnRef)) {
    return { ccnId: validatedCcn, ccnName: null, ccnRef: validatedCcnRef };
  }
  const found =
    find(propEq('ref', ccnRef), ccns) ||
    find(propEq('ref', ccnRef), otherCcns);
  return applySpec({ ccnId: prop('idcc'), ccnName: prop('name'), ccnRef: prop('ref') })(found);

};
